import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { storage } from './utils/storage';

import es from './locales/es.json';
import en from './locales/en.json';
import pt from './locales/pt.json';

// Initialize i18next with two separate instances/namespaces
// ui: for interface language
// menu: for menu content language (independent from UI)
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt }
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'pt'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// Menu language helpers — kept in sync with UI language via unified selector
export const getMenuLanguage = () => {
  return storage.get('menuLanguage') || i18n.language || 'es';
};

export const setMenuLanguage = (lng) => {
  storage.set('menuLanguage', lng);
  window.dispatchEvent(new Event('menuLanguageChange'));
};

// Sync menu language with UI language on init (unified selector)
i18n.on('initialized', () => {
  if (!storage.get('menuLanguage')) {
    storage.set('menuLanguage', i18n.language);
  }
});

export default i18n;
